export const URL_BASE = 'https://api.unsplash.com';
export const ACCESS_KEY = process.env.REACT_APP_UNSPLASH_ACCESS_KEY;
export const SECRET_KEY = process.env.REACT_APP_UNSPLASH_SECRET_KEY;
export const USERS_ENDPOINT = 'users';
export const PHOTOS_ENDPOINT = 'photos';
export const SEARCH_PHOTOS_ENDPOINT = 'search/photos';
export const IMAGES_PER_PAGE = 30;
export const INITIAL_PAGE = 0;
export const REFRESH_ELEMENTS_AT = 5;